/**
 * Andre Garen - sepet cekmecesi ekleri (Tur 23 EK10 \u00a73.1). Saat kararlari assets/ag-zaman.js (AGZaman).
 *  S087 [data-ag-zc]       zaman cizgisi: "Ayni gun kargo icin 2 sa 10 dk -> en gec Persembe kargoda -> 1-3 is gunu icinde teslim";
 *                          sayac yokken ilk nokta "Siparis ver"; gun adi temkinli kural (AGZaman.enGec); dakikada bir.
 *  S092 [data-ag-igkart]   yalniz Instagram tarayicisinda ve sepet doluyken; "Baglantiyi kopyala" /cart/<varyant>:<adet>,...
 *  S093 [data-ag-hediye]   "Bu bir hediye" ve not sepet ozelligi (/cart/update.js), 200 karakter.
 *  S089 [data-ag-kaydir]   satir sola kaydirilinca "Sonraya sakla" + "Kaldir"; [data-ag-sakla] dugmesi ayni eylem;
 *                          sonraya sakla = favorilere ekle + sepetten kaldir; 5 sn "Geri al".
 * Deneme anahtarli ogeler yalniz html.ag-deneme iken gorunur (snippets/ag-ozellikler.liquid).
 */
(function () {
  'use strict';
  var D = document.documentElement;
  function deneme() { return D.classList.contains('ag-deneme'); }
  function gorunur(el) { return !!el && (!el.hasAttribute('data-ag-oz-deneme') || deneme()); }
  function cumle(s) { s = String(s).toLocaleLowerCase('tr'); return s.charAt(0).toLocaleUpperCase('tr') + s.slice(1); }

  /* ---------------- S087 zaman cizgisi ---------------- */
  /* S087 (sepet) ve S029 (urun) ayni bilesen: [data-ag-zc] */
  var zcler = document.querySelectorAll('[data-ag-zc]');
  if (zcler.length && window.AGZaman) {
    var Z = window.AGZaman;
    Z.her(function (t) {
      var k = Z.kargo(t), e = Z.enGec(t), sayar = k.durum === 'SAYAC';
      var sa = Math.floor(k.kalanDk / 60), dk = k.kalanDk % 60;
      var okunus = (sayar ? cumle(Z.sayacMetni) + ' ' + (sa ? sa + ' saat ' : '') + dk + ' dakika. ' : 'Sipari\u015f ver. ') + 'En ge\u00e7 ' + e.gunAdi + ' kargoda. 1\u20133 i\u015f g\u00fcn\u00fc i\u00e7inde teslim.';
      [].forEach.call(zcler, function (zc) {
        zc.querySelector('[data-ag-zc-s1]').textContent = sayar ? cumle(Z.sayacMetni) : '\u015eimdi';
        zc.querySelector('[data-ag-zc-b1]').textContent = sayar ? k.sayac.toLocaleLowerCase('tr') : 'Sipari\u015f ver';
        zc.querySelector('[data-ag-zc-b2]').textContent = e.gunAdi + ' kargoda';
        if (sayar) zc.removeAttribute('data-ag-zc-sayacsiz'); else zc.setAttribute('data-ag-zc-sayacsiz', '');
        zc.querySelector('[data-ag-zc-sr]').textContent = okunus;
      });
    });
  }

  /* ---------------- S092 Instagram karti ---------------- */
  var ig = document.querySelector('[data-ag-igkart]');
  function igGoster(adet) {
    if (!ig) return;
    var kapali = false; try { kapali = sessionStorage.getItem('ag-ig-kart') === 'kapali'; } catch (e) {}
    ig.hidden = !(/Instagram/i.test(navigator.userAgent) && !kapali && adet > 0);
  }
  if (ig) {
    var ilkAdet = parseInt((document.querySelector('[data-ag-cart-count]') || {}).textContent, 10);
    if (isNaN(ilkAdet)) ilkAdet = document.querySelectorAll('[data-ag-cart-body] .ag-cart-line').length;
    igGoster(ilkAdet);
    document.addEventListener('ag:cart:updated', function (e) { igGoster(e.detail && e.detail.count); });
    ig.querySelector('[data-ag-igkart-kapat]').addEventListener('click', function () {
      try { sessionStorage.setItem('ag-ig-kart', 'kapali'); } catch (e) {}
      ig.hidden = true;
      var b = document.querySelector('.ag-drawer__title'); if (b) { b.setAttribute('tabindex', '-1'); b.focus(); }
    });
    ig.querySelector('[data-ag-igkart-kopyala]').addEventListener('click', function () {
      var dug = this, bag = ig.querySelector('[data-ag-igkart-bag]'), srEl = ig.querySelector('[data-ag-igkart-sr]');
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        if (!c.items || !c.items.length) return;
        if (c.items.some(function (i) { return i.selling_plan_allocation; })) { ig.hidden = true; return; }
        var url = location.origin + '/cart/' + c.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',') + '?storefront=true';
        var bitti = function () {
          dug.textContent = 'Kopyaland\u0131'; dug.setAttribute('data-tamam', '');
          bag.textContent = url.replace(/^https?:\/\//, '').slice(0, 64) + (url.length > 72 ? '\u2026' : ''); bag.hidden = false;
          srEl.textContent = 'Sepet ba\u011flant\u0131s\u0131 kopyaland\u0131, ' + c.item_count + ' \u00fcr\u00fcn';
        };
        var yedek = function () {
          var ta = document.createElement('textarea'); ta.value = url; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;opacity:0;top:0';
          document.body.appendChild(ta); ta.select(); var ok = false; try { ok = document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
          if (ok) bitti(); else { bag.textContent = url; bag.hidden = false; }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(bitti, yedek); else yedek();
      }).catch(function () {});
    });
  }

  /* ---------------- S093 hediye notu ---------------- */
  var hd = document.querySelector('[data-ag-hediye]');
  if (hd) {
    var ac = hd.querySelector('[data-ag-hediye-ac]'), alan = hd.querySelector('[data-ag-hediye-alan]'), not = hd.querySelector('[data-ag-hediye-not]'), say = hd.querySelector('[data-ag-hediye-sayac]');
    var zam = null;
    var kaydet = function () {
      clearTimeout(zam);
      zam = setTimeout(function () {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Hediye': ac.checked ? 'Evet' : '', 'Hediye notu': ac.checked ? not.value.slice(0, 200) : '' } }) }).catch(function () {});
      }, 500);
    };
    ac.addEventListener('change', function () { alan.hidden = !ac.checked; kaydet(); });
    not.addEventListener('input', function () { say.textContent = not.value.length; kaydet(); });
  }

  /* ---------------- S089 sonraya sakla ---------------- */
  function satirAktif(line) { var v = line.getAttribute('data-ag-kaydir'); return v === '' || (v === 'deneme' && deneme()); }
  function tost(metin, geriAl) {
    var el = document.querySelector('.ag-sepet-tost'); if (el) el.remove();
    el = document.createElement('div'); el.className = 'ag-sepet-tost'; el.setAttribute('role', 'status');
    var sp = document.createElement('span'); sp.textContent = metin; el.appendChild(sp);
    if (geriAl) { var b = document.createElement('button'); b.type = 'button'; b.textContent = 'Geri al'; b.addEventListener('click', function () { el.remove(); geriAl(); }); el.appendChild(b); }
    document.body.appendChild(el);
    setTimeout(function () { if (el.parentNode) el.remove(); }, 5000);
  }
  function sakla(line) {
    if (!line || !window.AGCart) return;
    var key = line.getAttribute('data-ag-key'), vid = line.getAttribute('data-ag-variant'), adet = parseInt(line.getAttribute('data-ag-adet'), 10) || 1;
    var fav = line.querySelector('[data-ag-fav-toggle]');
    if (fav && fav.getAttribute('aria-pressed') !== 'true') fav.click();
    window.AGCart.change(key, 0).then(function () {
      tost('Sonraya sakland\u0131, favorilerinde', function () { window.AGCart.add([{ id: +vid, quantity: adet }]).catch(function () {}); });
    }).catch(function (e) { if (window.AGCart.announce) window.AGCart.announce(e.message); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ag-sakla]');
    if (b && gorunur(b)) { e.preventDefault(); sakla(b.closest('.ag-cart-line')); return; }
    var k = e.target.closest('[data-ag-kaydir-eylem]');
    if (k) {
      e.preventDefault();
      var line = k.closest('.ag-cart-line');
      if (k.getAttribute('data-ag-kaydir-eylem') === 'sakla') sakla(line);
      else { var r = line.querySelector('.ag-cart-line__remove'); if (r) r.click(); }
    }
  });
  var x0 = null, y0 = null, hedef = null;
  document.addEventListener('touchstart', function (e) {
    var line = e.target.closest && e.target.closest('.ag-cart-line[data-ag-kaydir]');
    if (!line || !satirAktif(line)) { hedef = null; return; }
    hedef = line; x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!hedef) return;
    var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0, line = hedef; hedef = null;
    if (Math.abs(dy) > 30 || Math.abs(dx) < 45) return;
    [].forEach.call(document.querySelectorAll('.ag-cart-line[data-acik]'), function (l) { if (l !== line) l.removeAttribute('data-acik'); });
    if (dx < 0) {
      if (!line.querySelector('.ag-kaydir-eylem')) {
        var p = document.createElement('div'); p.className = 'ag-kaydir-eylem'; p.setAttribute('aria-hidden', 'true');
        p.innerHTML = '<button type="button" tabindex="-1" data-ag-kaydir-eylem="sakla">Sonraya sakla</button><button type="button" tabindex="-1" data-ag-kaydir-eylem="kaldir">Kald\u0131r</button>';
        line.appendChild(p);
      }
      line.setAttribute('data-acik', '');
    } else line.removeAttribute('data-acik');
  });
})();
